import { render, staticRenderFns } from "./ItsSalesRegPriceDetail.vue?vue&type=template&id=1854ab7c&scoped=true&"
import script from "./ItsSalesRegPriceDetail.vue?vue&type=script&lang=js&"
export * from "./ItsSalesRegPriceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsSalesRegPriceDetail.vue?vue&type=style&index=0&id=1854ab7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1854ab7c",
  null
  
)

export default component.exports